// Fix 21: Account Suspended screen
import { useApp } from '../context/AppContext';
import { G } from '../constants';

export default function SuspendedScreen() {
  const { setUser } = useApp();
  return (
    <div style={{ position:'fixed', inset:0, background:'#0D0A00', zIndex:9999,
      display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:32, textAlign:'center' }}>
      <div style={{ fontSize:64, marginBottom:16 }}>🚫</div>
      <div style={{ fontWeight:900, color:'#F6465D', fontSize:24, marginBottom:10 }}>Account Suspended</div>
      <div style={{ color:'#888', fontSize:14, lineHeight:1.7, maxWidth:320, marginBottom:28 }}>
        Your account has been suspended due to a violation of our community guidelines.
        If you believe this is a mistake, please contact our support team.
      </div>
      <a href="mailto:support@papercrypto.app"
        style={{ padding:'12px 28px', borderRadius:20, border:`1px solid ${G}44`,
          background:`${G}15`, color:G, fontWeight:700, fontSize:14,
          textDecoration:'none', marginBottom:12, display:'block' }}>
        📧 Contact Support
      </a>
      <button onClick={() => { localStorage.removeItem('pc_token'); setUser(null); }}
        style={{ background:'none', border:'none', color:'#555', cursor:'pointer', fontSize:13 }}>
        Sign Out
      </button>
    </div>
  );
}
